import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import { transformPhoneNumber } from '../../../internationalization/phone-util'
import { copyToClipboard } from '../../../../util/copy-to-clipboard'
import localizedText from '../../../../util/localized-text-with-replacements'
import { getEmailForCountryCode, getTreatmentCheckoutForCountryCode } from '../../../../util/localized-urls'
import * as macros from '../../resources/whatsAppMacros'
import currentUserHasAccess from '../../../../util/widget-helper'
import { WHATS_APP_TEXT_WIDGET_CONTAINER } from '../../../process/ui-definition/process-ui'

const TEXTS = {
    treatmentQuotationCreated: localizedText({
        DE: macros.TREATMENT_QUOTATION_CREATED_DE,
        GB: macros.TREATMENT_QUOTATION_CREATED_GB,
        CH: macros.TREATMENT_QUOTATION_CREATED_CH
    }),
    treatmentQuotationReminder1: localizedText({
        DE: macros.TREATMENT_QUOTATION_REMINDER_DE,
        GB: macros.TREATMENT_QUOTATION_REMINDER_GB
    }),
    treatmentQuotationReminder2: localizedText({
        DE: macros.TREATMENT_QUOTATION_REMINDER2_DE,
        GB: macros.TREATMENT_QUOTATION_REMINDER2_GB,
        CH: macros.TREATMENT_QUOTATION_REMINDER2_CH,
    }),
    treatmentQuotationReminder2Voucher: localizedText({
        DE: macros.TREATMENT_QUOTATION_REMINDER_VOUCHER_DE,
        GB: macros.TREATMENT_QUOTATION_REMINDER_VOUCHER_GB,
        CH: macros.TREATMENT_QUOTATION_REMINDER_VOUCHER_CH,
    }),
}

const createWhatsAppUrl = (text, phone, countryCode) => {
    const transformedNumber = transformPhoneNumber(phone, countryCode)
    const transformedText = encodeURIComponent(text)
    return `https://wa.me/${transformedNumber}?text=${transformedText}`
}

const getText = ({ textId, customer, context }) => {
    const textTemplate = TEXTS[textId]
    return textTemplate(customer.countryCode, {
        firstName: customer.firstName,
        lastName: customer.lastName,
        salutation: customer.gender,
        websiteUrl: getTreatmentCheckoutForCountryCode(customer.countryCode),
        emailAddress: getEmailForCountryCode(customer.countryCode),
        voucherCode: context.voucherCode,
    })
}

const WhatsAppMacroContainer = ({ label, whatsAppUrl, text }) => {
    return <Row>
        <Column size={12}>
            <div className="whatsapp-message">
                {label && <label style={{ display: 'block' }} className="control-label">With voucher</label>}
                <a href={whatsAppUrl} target="_blank" rel="noopener noreferrer">Quick Link</a>
                <div className="input-group">
                    <textarea readOnly={true} className="form-control text-area-default form-control whatsapp-message-textarea" value={text} />
                    <span className="input-group-btn">
                        <button
                            className="btn btn-primary"
                            onClick={() => {
                                copyToClipboard(text)
                            }}>
                            <i className="fa fa-copy" />
                        </button>
                    </span>

                </div>
            </div>
        </Column>
    </Row>
}

const WhatsAppTextWidget = ({ readOnly, customer, textId, context = {} }) => {
    if (!currentUserHasAccess(WHATS_APP_TEXT_WIDGET_CONTAINER)) {
        return null
    }

    const text = getText({ textId, customer, context })
    const whatsAppUrl = createWhatsAppUrl(text, customer.phone, customer.countryCode)
    let voucherText = null
    let whatsAppVoucherUrl = null
    if (textId === 'treatmentQuotationReminder2') {
        voucherText = getText({ textId: 'treatmentQuotationReminder2Voucher', customer, context })
        whatsAppVoucherUrl = createWhatsAppUrl(voucherText, customer.phone, customer.countryCode)
    }

    return (
        <ContentBox title="WhatsApp Text">
            <WhatsAppMacroContainer label={''} text={text} whatsAppUrl={whatsAppUrl} />
            {voucherText && <WhatsAppMacroContainer label={'With voucher'} text={voucherText} whatsAppUrl={whatsAppVoucherUrl} />}
        </ContentBox>
    )
}

WhatsAppTextWidget.propTypes = {
    readOnly: PropTypes.bool.isRequired,
    customer: PropTypes.object.isRequired,
    textId: PropTypes.string.isRequired,
    context: PropTypes.object,
}

export default WhatsAppTextWidget



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/WhatsAppTextWidget.js